import React from "react";

export default function TextMessageComponent({ message }) {
  return <span>{message.message}</span>;
}
